var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.713501 6.38294V14.6171C0.713501 15.1412 0.996278 15.6265 1.45742 15.8886L8.67912 20.0035C9.14027 20.2655 9.70582 20.2655 10.167 20.0035L17.3887 15.8886C17.8498 15.6265 18.1326 15.1412 18.1326 14.6171V6.38294C18.1326 5.85891 17.8498 5.37353 17.3887 5.11151L10.167 0.996561C9.70582 0.734545 9.14027 0.734545 8.67912 0.996561L1.45742 5.11151C1.00063 5.37353 0.713501 5.85891 0.713501 6.38294Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0023 12.096L9.9712 14.8836C9.94075 14.961 9.94075 15.0469 9.9712 15.1242L11.7418 19.9221L13.7909 18.7538L11.3329 12.096C11.2763 11.9413 11.0588 11.9413 11.0023 12.096Z",
    fill: "#12AAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0645 7.40528C13.0079 7.25065 12.7904 7.25065 12.7338 7.40528L11.7028 10.193C11.6723 10.2703 11.6723 10.3562 11.7028 10.4335L14.6045 18.2897L16.6536 17.1214L13.0645 7.40528Z",
    fill: "#12AAFF"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.42301 1.30149C9.47522 1.30149 9.52307 1.31438 9.57093 1.34015L17.3843 5.79444C17.4756 5.84598 17.5322 5.94048 17.5322 6.04357V14.9521C17.5322 15.0552 17.4756 15.1497 17.3843 15.2013L9.57093 19.6598C9.52742 19.6856 9.47522 19.6985 9.42301 19.6985C9.37081 19.6985 9.32295 19.6856 9.2751 19.6598L1.46609 15.2056C1.37473 15.154 1.31818 15.0595 1.31818 14.9564V6.04357C1.31818 5.94048 1.37473 5.84598 1.46609 5.79444L9.27945 1.34015C9.32295 1.31438 9.37516 1.30149 9.42301 1.30149ZM9.42301 0C9.14459 0 8.86616 0.0730211 8.61819 0.214768L0.804828 4.66905C0.30888 4.95255 0 5.47658 0 6.04357V14.9521C0 15.5191 0.30888 16.0475 0.804828 16.3309L8.61819 20.7852C8.86616 20.927 9.14459 21 9.42301 21C9.70144 21 9.97987 20.927 10.2278 20.7852L18.0412 16.3309C18.5415 16.0475 18.846 15.5234 18.846 14.9521V6.04357C18.846 5.47658 18.5371 4.94825 18.0412 4.66476L10.2322 0.214768C9.97987 0.0730211 9.70144 0 9.42301 0Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.25903 18.2982L4.97685 16.3567L6.42119 17.5422L5.07256 18.7621L4.25903 18.2982Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.76617 5.40796H6.78673C6.63881 5.40796 6.50395 5.49816 6.45609 5.63561L2.21008 17.13L4.25913 18.2983L8.93583 5.63991C8.97499 5.52823 8.89233 5.40796 8.76617 5.40796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.2334 5.40796H10.254C10.1061 5.40796 9.97121 5.49816 9.92335 5.63561L5.07263 18.7622L7.12168 19.9306L12.3987 5.6442C12.4422 5.52823 12.3552 5.40796 12.2334 5.40796Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArb);
export default __webpack_public_path__ + "static/media/arb.a4165b58f63ff235174ee3593a3ddfe1.svg";
export { ForwardRef as ReactComponent };